import t from "react";
import { useTheme as h, useBreakpointValue as D, List as I, ListItem as S, Link as T, Box as _, Image as z, Text as L } from "@chakra-ui/react";
import "@chakra-ui/system";
import { typographyBreakpoints as $ } from "../../../utils/typographyUtils.js";
import { isBrowser as R } from "../../../utils/commonUtils.js";
import { AnalyticsEventType as V } from "../../../types/analytics.enums.js";
import "../../atoms/link/button-link.js";
const U = ({
  navigationItems: u,
  tabsAriaLabel: d,
  tabClickHandler: b,
  trackingFn: f
}) => {
  const {
    borderWidth: { medium: m },
    common: { common01Regular: n, common02Regular: l, common01Bold: y },
    iconSize: { l: E },
    element: { spacingMedium: i, spacingExtraLarge: k },
    action: { primaryDefault: g, primaryHover: p, primaryPressed: s }
  } = h(), x = (o, e, r) => {
    o.preventDefault(), f(V.UI_ENGAGEMENT, {
      name: r
    }), b(e);
  }, c = D($, {
    ssr: !R(),
    fallback: "base"
  }) === "Desktop";
  return /* @__PURE__ */ t.createElement("nav", { "aria-label": d || "" }, /* @__PURE__ */ t.createElement(I, { display: "flex", listStyleType: "none", p: 0 }, u.map(({ url: o, isActive: e, icon: r, displayText1: a }) => /* @__PURE__ */ t.createElement(
    S,
    {
      onClick: (B) => x(B, o, a),
      key: a,
      mr: k,
      p: "0",
      _hover: {
        borderBottom: !e && `${m} solid ${p}`
      },
      "data-testid": "tab-list-item"
    },
    /* @__PURE__ */ t.createElement(
      T,
      {
        "aria-current": e ? "page" : void 0,
        display: "flex",
        alignItems: "center",
        href: o,
        borderBottom: e ? `${m} solid ${s}` : "none",
        color: e && c ? n : l,
        style: {
          textDecoration: "none"
        }
      },
      r && /* @__PURE__ */ t.createElement(_, { boxSize: E, mr: i }, /* @__PURE__ */ t.createElement(
        z,
        {
          boxSize: "100%",
          src: r.url,
          alt: r.altText || ""
        }
      )),
      /* @__PURE__ */ t.createElement(
        L,
        {
          _hover: {
            color: p
          },
          color: e ? s : g,
          py: i,
          sx: {
            ...c ? n : l,
            ...e ? y : {}
          }
        },
        a
      )
    )
  ))));
};
export {
  U as Tabs
};
